"use client";

import { useRef, useState, useEffect } from "react";
import { motion, useSpring } from "framer-motion";
import { ArrowRight, Image as ImageIcon, Building2, TrendingUp, Globe, Bot, CreditCard, ChartNoAxesCombined } from "lucide-react";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { StickyTabsList } from "@/features/shared/components/sticky-tabs-list";
import { PmsOrcamentoModal } from "./pms-orcamento-modal";

// ── Data ──────────────────────────────────────────────────────────────────────

const pmsIntegrados = [
  {
    id: "plus",
    nome: "Plus",
    logo: "/assets/imgs/integracoes/pms/plus.webp",
    descricao:
      "Sistema de gestão hoteleira em nuvem desenvolvido pela Foco Tecnologia, para pequenos hoteleiros. Integrado ao motor de reservas e ao gestor de canais, os clientes terão a tranquilidade de disponibilizar 100% das suas ocupações para vendas em Mais de 800 canais integrados, sem overbookings.",
  },
  {
    id: "adm",
    nome: "ADM",
    logo: "/assets/imgs/integracoes/pms/adm-hoteleiro.svg",
    descricao:
      "A ADM Desenvolvimento de Sistemas é uma empresa de tecnologia, sediada em Ilhéus-BA, criada em 2008, que desenvolve e comercializa o ADM Hotel e o ADM Restaurante, ferramentas para gestão de hotéis, pousadas, bares, restaurantes e similares com mais de 1200 licenças em todo o Brasil.",
  },
  {
    id: "bitz",
    nome: "Bitz",
    logo: "/assets/imgs/integracoes/pms/bitz.svg",
    descricao:
      "A Bitz Softwares está há mais de 9 anos no mercado, uma empresa de tecnologia especializada no setor hoteleiro. Nosso propósito é gerar ótimas experiências para as pessoas. Facilitando suas vidas, economizando seu tempo e aumentando seu rendimento no dia-a-dia.",
  },
  {
    id: "carsoft",
    nome: "Carsoft",
    logo: "/assets/imgs/integracoes/pms/carsoft.svg",
    descricao:
      "Xenios: Sistema de gestão de hotéis, pousadas e hostels de fácil utilização. Possui integração com outros módulos como estoque, restaurante, financeiro, eventos, controle de serviços e reserva online direto pelo site do hotel/pousada. Conta com suporte 24 horas.",
  },
  {
    id: "coniahoteis",
    nome: "ConIA Hotéis",
    logo: "/assets/imgs/integracoes/pms/conia.webp",
    descricao:
      "Soluções para Gestão Hoteleira e E.R.P. Facilite a gestão do seu hotel, pousada ou resort com a ferramenta certa para o seu negócio!",
  },
  {
    id: "controlhotel",
    nome: "Control Hotel Softwares",
    logo: "/assets/imgs/integracoes/pms/control-hotel.svg",
    descricao:
      "Automatize reservas, controle o financeiro e gerencie seu hotel com um sistema 100% em nuvem e multi hotel. Tenha mais eficiência, reduza custos e facilite sua operação com uma plataforma intuitiva e completa.",
  },
  /*{
    id: "desbravador",
    nome: "Desbravador",
    logo: "/assets/imgs/integracoes/pms/desbravador.webp",
    descricao:
      "Atuamos no desenvolvimento de software para a gestão de hotéis desde 1988. Somos Desbravadores! Atendemos hotéis de pequeno, médio e grande porte, fornecendo soluções que otimizam suas operações e aprimoram a experiência do hóspede. Hoje são mais de 3.500 clientes espalhados em dez países.",
  },*/
  {
    id: "esolution",
    nome: "eSolution",
    logo: "/assets/imgs/integracoes/pms/esolution.svg",
    descricao:
      "A eSolution é uma empresa de software que está no mercado desde 2007. Sua atuação está focada em softwares de gestão em hotelaria e parques temáticos. Com um ideal de excelência, ela vem ganhando destaque nesses setores.",
  },
  {
    id: "hmax",
    nome: "HMAX",
    logo: "/assets/imgs/integracoes/pms/hmax.svg",
    descricao:
      "A HMAX é uma empresa pioneira no mercado de automação hoteleira. O nosso sistema de gestão oferece 30 anos de conhecimento organizados em módulos, que você pode contratar segundo a sua necessidade. O PMS HMAX está integrado com a Foco Multimídia.",
  },
  {
    id: "hotelflow",
    nome: "Hotelflow",
    logo: "/assets/imgs/integracoes/pms/hotelflow.svg",
    descricao:
      "Com o Hotelflow, você tem em mãos um gerenciamento moderno, prático e intuitivo para aumentar a produtividade do seu empreendimento hoteleiro. O sistema é web, não requer instalação, basta acessar pelo seu navegador e usar de qualquer lugar, até mesmo do seu dispositivo móvel!",
  },
  {
    id: "isasoft",
    nome: "Isasoft",
    logo: "/assets/imgs/integracoes/pms/isasoft.svg",
    descricao:
      "Empresa voltada para o desenvolvimento de sistemas para gerenciamento de micros e pequenas empresas do comércio para todo o território nacional. O Isasoft Inn, foi desenvolvido para administrar pousadas, hotéis e resorts de forma rápida e profissional.",
  },
  {
    id: "mde",
    nome: "MDE",
    logo: "/assets/imgs/integracoes/pms/mde.svg",
    descricao:
      "Há mais de 27 anos a MDE Informática projeta e desenvolve Sistemas de Gestão para os segmentos Hoteleiro e Motelero. Nosso diferencial está em oferecer soluções personalizadas para a necessidade específica de cada cliente.",
  },
  {
    id: "newhotel",
    nome: "Newhotel",
    logo: "/assets/imgs/integracoes/pms/newhotel.svg",
    descricao:
      "Uma empresa de software especializada em desenvolver sistemas para gestão hoteleira. Pioneiros internacionais em soluções Cloud para o setor hoteleiro, estamos no mercado há 37 anos e possuímos um portfólio com mais de 6 mil hotéis, em 64 países.",
  },
  {
    id: "queops",
    nome: "Queops",
    logo: "/assets/imgs/integracoes/pms/queops.svg",
    descricao:
      "A Quéops possui integração com a Foco, permitindo uma comunicação direta entre os sistemas para troca de informações como disponibilidade, tarifas e reservas. Essa conexão otimiza rotinas, evita inconsistências de dados e facilita o controle da operação hoteleira.",
  },
  {
    id: "sachar",
    nome: "Sachar",
    logo: "/assets/imgs/integracoes/pms/saghar.svg",
    descricao:
      "A Sachar (SGH) possui integração com a Foco, permitindo uma comunicação direta entre os sistemas para troca de informações como disponibilidade, tarifas e reservas. Essa conexão otimiza rotinas, evita inconsistências de dados e facilita o controle da operação hoteleira.",
  },
  {
    id: "silbeck",
    nome: "Silbeck",
    logo: "/assets/imgs/integracoes/pms/silbeck.svg",
    descricao:
      "Somos uma empresa de software para gestão hoteleira. Atuamos há 25 anos no mercado com foco na busca da excelência em nosso atendimento e no desenvolvimento de nossos produtos. O nosso objetivo nunca foi oferecer apenas um sistema de gestão.",
  },
  {
    id: "simplehotel",
    nome: "Simplehotel",
    logo: "/assets/imgs/integracoes/pms/simplehotel.svg",
    descricao:
      "A Simple Hotel possui integração com a Foco, permitindo uma comunicação direta entre os sistemas para troca de informações como disponibilidade, tarifas e reservas. Essa conexão otimiza rotinas, evita inconsistências de dados e facilita o controle da operação hoteleira.",
  },
  {
    id: "techside",
    nome: "Techside",
    logo: "/assets/imgs/integracoes/pms/techside.svg",
    descricao:
      "A TechSide (TechHotel) possui integração com a Foco, permitindo uma comunicação direta entre os sistemas para troca de informações como disponibilidade, tarifas e reservas. Essa conexão otimiza rotinas, evita inconsistências de dados e facilita o controle da operação hoteleira.",
  },
  {
    id: "to-de-ferias",
    nome: "Tô de Férias",
    logo: "/assets/imgs/integracoes/pms/to-de-ferias.svg",
    descricao:
      "O TDF Hotel é um PMS completo, integrando as rotinas de recepção, reservas, governança, financeiro e estoque, que possui integrações comerciais e administrativas, além de configurações personalizadas e foco no relacionamento entre hoteleiro e hóspede.",
  },
  {
    id: "totvs",
    nome: "TOTVS",
    logo: "/assets/imgs/integracoes/pms/totvs.svg",
    descricao:
      "A TOTVS cresce junto com a sua empresa. Aumente sua eficiência operacional e produtividade com um software completo para gestão e automação de processos. Não perca tempo e automatize a sua gestão de reservas, unificando toda a sua disponibilidade em um só sistema.",
  },
];

// Logo "" propositalmente — aguardando os arquivos das marcas. PmsCard já
// sabe renderizar um placeholder nesse caso (ver bloco "Logo" abaixo).
const marketingHoteleiro = [
  {
    id: "tribuzana",
    nome: "Tribuzana",
    logo: "/assets/imgs/logos/tribuzana.svg",
    descricao:
      "Autoridade no segmento, há mais de 10 anos ao lado dos hoteleiros com soluções que unem estratégia e tecnologia para transformar meios de hospedagem.",
  },
  {
    id: "reprotel",
    nome: "Reprotel",
    logo: "/assets/imgs/logos/reprotel.svg",
    descricao:
      "Reprotel oferece sistemas completos para hotéis e pousadas, integrando reservas, finanças e canais de venda para mais eficiência, economia e resultados.",
  },
  {
    id: "storm",
    nome: "Storm",
    logo: "/assets/imgs/logos/storm.svg",
    descricao:
      "Na Storm, unimos branding estratégico e identidade visual para posicionar sua empresa com autoridade e atrair clientes certos.",
  },
];

const canalDeVendas = [
  {
    id: "b2b-reservas",
    nome: "B2B Reservas",
    logo: "/assets/imgs/logos/b2b-reservas.svg",
    descricao:
      "A B2B Reservas conecta hotéis e pousadas a centenas de agências e operadoras, ampliando vendas e fortalecendo a distribuição hoteleira.",
  },
  {
    id: "decolar",
    nome: "Decolar",
    logo: "/assets/imgs/logos/decolar.svg",
    descricao:
      "Cadastre seu hotel com suporte da Foco, ganhe comissão especial e destaque sua propriedade na Decolar.com com voucher exclusivo.",
  },
  {
    id: "expedia",
    nome: "Expedia",
    logo: "/assets/imgs/logos/expedia.svg",
    descricao:
      "Cadastre seu hotel com o apoio da Foco, aproveite comissionamento reduzido por 180 dias e acesse a distribuição global e B2B do Expedia.",
  },
  {
    // Wordmark monocromático em /logos, não o selo de parceria que a
    // CertificacoesSection usa (/certificacoes/onfly.svg): são dois arquivos
    // diferentes da mesma marca, de propósito. Aqui o card aplica
    // grayscale no repouso e cor no hover, tratamento que só funciona num
    // logotipo de fundo transparente — o selo tem pílula de fundo própria.
    id: "onfly",
    nome: "Onfly",
    logo: "/assets/imgs/logos/onfly.svg",
    descricao:
      "Cadastre seu hotel com o apoio da Foco e receba a demanda corporativa da Onfly, plataforma de gestão de viagens usada por milhares de empresas.",
  },
];

const chatbotIa = [
  {
    id: "asksuite",
    nome: "Asksuite",
    logo: "/assets/imgs/logos/asksuite.svg",
    descricao:
      "Conheça o melhor chatbot de reservas e plataforma de atendimento para hotéis do mundo, e comece hoje a revolucionar as interações do seu hotel via WhatsApp, Instagram, Chat do Site, telefone e email.",
  },
];

const adquirentes = [
  {
    id: "stone",
    nome: "Stone",
    logo: "/assets/imgs/logos/stone.svg",
    descricao:
      "Transforme a experiência de pagamento do seu hóspede com Pix, cartão e maquininhas integrados ao sistema Foco, sem complicação.",
  },
];

// Textos levantados nos sites oficiais e checados afirmação por afirmação
// contra a fonte (out/2026). Ficaram de fora de propósito o que não se
// sustentava ou divergia entre fontes: ano de fundação (2013 x 2016 na
// bebook, 2018 x 2019 na VOA), números de clientes e de faturamento
// gerido, e os superlativos dos próprios parceiros ("o melhor RMS do
// Brasil"). A integração com a Foco tem fonte em todos os três: a bebook e
// o Sistema IO listam a Foco entre as integrações nativas nos sites deles;
// a da VOA está nos posts do próprio blog da Foco. Grafia das marcas como
// cada uma escreve — "bebook" minúsculo, "Sistema IO" com espaço.
const rms = [
  {
    id: "bebook",
    nome: "bebook",
    logo: "/assets/imgs/logos/bebook.svg",
    descricao:
      "A bebook é uma plataforma de Revenue Management e Business Intelligence para hotéis, pousadas e redes hoteleiras. Integrada à Foco, ajusta tarifas automaticamente com base em regras definidas pelo hotel, monitora a concorrência e usa inteligência artificial para prever ocupação, ADR e RevPAR.",
  },
  {
    id: "sistema-io",
    nome: "Sistema IO",
    logo: "/assets/imgs/logos/sistema-io.svg",
    descricao:
      "O Sistema IO é uma plataforma de Revenue Management desenvolvida por profissionais da hotelaria brasileira, que reúne RMS, rate shopper e BI em uma única solução. Possui conexão nativa com a Foco, sugere tarifas com base em ocupação, mercado e histórico e prevê ocupação, ADR e receita.",
  },
  {
    id: "voa-hoteis",
    nome: "VOA Hotéis",
    logo: "/assets/imgs/logos/voa-hoteis.svg",
    descricao:
      "A VOA Hotéis é especialista em distribuição e precificação para hotéis. Une uma equipe dedicada de Revenue Management a um sistema próprio de precificação dinâmica, que ajusta tarifas conforme demanda, concorrência e sazonalidade. A integração com a Foco possibilita a flutuação tarifária automática, mantendo os preços competitivos.",
  },
];

const categorias = [
  { id: "pms",             label: "PMS",                icon: Building2,  itens: pmsIntegrados },
  { id: "marketing",       label: "Marketing Hoteleiro", icon: TrendingUp, itens: marketingHoteleiro },
  { id: "canal-de-vendas", label: "Canal de vendas",     icon: Globe,      itens: canalDeVendas },
  { id: "chatbot-ia",      label: "Chatbot e IA",        icon: Bot,        itens: chatbotIa },
  { id: "adquirentes",     label: "Adquirentes",         icon: CreditCard, itens: adquirentes },
  { id: "rms",             label: "RMS",                 icon: ChartNoAxesCombined, itens: rms },
];

// Categorias com poucos itens (1-3) não devem esticar pelas 4 colunas —
// fica um card solto boiando num grid vazio. Limita as colunas ao que a
// categoria realmente tem e centraliza.
function gridColsClass(count: number) {
  if (count <= 1) return "grid-cols-1 max-w-sm mx-auto";
  if (count === 2) return "grid-cols-1 sm:grid-cols-2 max-w-2xl mx-auto";
  if (count === 3) return "grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 max-w-4xl mx-auto";
  return "grid-cols-1 sm:grid-cols-2 lg:grid-cols-4";
}

// ── MagneticButton ────────────────────────────────────────────────────────────

const MAGNETIC_RADIUS   = 68;
const MAGNETIC_STRENGTH = 0.30;

function MagneticButton({ onClick }: { onClick: () => void }) {
  const outerRef = useRef<HTMLDivElement>(null);
  const [hovered, setHovered] = useState(false);

  const magX = useSpring(0, { stiffness: 150, damping: 15, mass: 0.1 });
  const magY = useSpring(0, { stiffness: 150, damping: 15, mass: 0.1 });

  useEffect(() => {
    const onMove = (e: MouseEvent) => {
      const el = outerRef.current;
      if (!el) return;
      const r  = el.getBoundingClientRect();
      const cx = r.left + r.width  / 2;
      const cy = r.top  + r.height / 2;
      const dx = e.clientX - cx;
      const dy = e.clientY - cy;
      const dist = Math.hypot(dx, dy);
      if (dist < MAGNETIC_RADIUS) {
        const f = (1 - dist / MAGNETIC_RADIUS) * MAGNETIC_STRENGTH;
        magX.set(dx * f);
        magY.set(dy * f);
      } else {
        magX.set(0);
        magY.set(0);
      }
    };
    window.addEventListener("mousemove", onMove, { passive: true });
    return () => window.removeEventListener("mousemove", onMove);
  }, [magX, magY]);

  return (
    <div ref={outerRef} className="w-full">
      <motion.button
        type="button"
        onClick={onClick}
        style={{ x: magX, y: magY }}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => {
          setHovered(false);
          magX.set(0);
          magY.set(0);
        }}
        whileTap={{ scale: 0.96 }}
        className="relative w-full flex items-center justify-center gap-2 text-sm font-medium px-4 py-2.5 rounded-full overflow-hidden border border-slate-200 text-slate-600 transition-colors duration-300 shadow-sm hover:shadow-md hover:shadow-blue-500/20 hover:text-white hover:border-transparent"
      >
        <span
          className={`absolute inset-0 bg-gradient-to-r from-[#1e3a5f] to-[#285992] transition-opacity duration-300 ${
            hovered ? "opacity-100" : "opacity-0"
          }`}
        />
        <span className="relative z-10">Solicite orçamento</span>
        <motion.span
          className="relative z-10 flex-shrink-0"
          animate={{ x: hovered ? 4 : 0 }}
          transition={{ duration: 0.22, ease: "easeOut" }}
        >
          <ArrowRight className="w-4 h-4" />
        </motion.span>
      </motion.button>
    </div>
  );
}

// ── PmsCard ───────────────────────────────────────────────────────────────────

interface PmsItem {
  id:        string;
  nome:      string;
  logo:      string;
  descricao: string;
}

interface PmsCardProps {
  pms:              PmsItem;
  index:            number;
  isHovered:        boolean;
  onEnter:          () => void;
  onSolicitar:      () => void;
}

function PmsCard({ pms, index, isHovered, onEnter, onSolicitar }: PmsCardProps) {
  return (
    // Outer div: scroll entrance animation
    <motion.div
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-40px" }}
      transition={{
        type:      "spring",
        damping:   20,
        stiffness: 100,
        delay:     (index % 4) * 0.06,
      }}
    >
      {/* Inner div: hover lift do próprio card (o blur nos outros cards ao
          lado — sibling focus/blur — foi removido a pedido explícito). */}
      <motion.div
        onMouseEnter={onEnter}
        animate={{
          scale:     isHovered ? 1.02  : 1,
          boxShadow: isHovered
            ? "0 16px 48px rgba(30,58,95,0.13), 0 4px 12px rgba(30,58,95,0.06)"
            : "0 1px 3px rgba(0,0,0,0.06), 0 1px 2px rgba(0,0,0,0.04)",
        }}
        transition={{ duration: 0.3, ease: "easeInOut" }}
        className="relative bg-white rounded-3xl border border-slate-100 overflow-hidden flex flex-col h-full"
      >
        <div className="p-5 flex flex-col h-full">

          {/* Logo — placeholder discreto (borda tracejada) enquanto o
              arquivo da marca ainda não existe; troca sozinho pra imagem
              real assim que `logo` for preenchido nos dados. */}
          <div className="h-14 flex items-center justify-center mb-4">
            {pms.logo ? (
              <img
                src={pms.logo}
                alt={pms.nome}
                width={228}
                height={80}
                loading="lazy"
                decoding="async"
                className="max-h-full max-w-[140px] w-auto object-contain transition-all duration-500"
                style={{
                  filter:    isHovered ? "grayscale(0%) opacity(1)"   : "grayscale(100%) opacity(0.5)",
                  transform: isHovered ? "scale(1.06)" : "scale(1)",
                }}
              />
            ) : (
              <div className="flex flex-col items-center justify-center gap-1 w-full h-full rounded-lg border border-dashed border-slate-200 text-slate-300">
                <ImageIcon className="w-4 h-4" strokeWidth={1.5} />
                <span className="text-[10px] font-medium tracking-wide">Logo</span>
              </div>
            )}
          </div>

          <p className="text-slate-600 text-sm leading-relaxed flex-grow mb-4">
            {pms.descricao}
          </p>

          <MagneticButton onClick={onSolicitar} />
        </div>
      </motion.div>
    </motion.div>
  );
}

// ── Section ───────────────────────────────────────────────────────────────────

function PmsIntegradosSection() {
  const [activeTab, setActiveTab] = useState(categorias[0].id);
  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);
  const [activePms, setActivePms] = useState<PmsItem | null>(null);
  const sectionRef = useRef<HTMLElement>(null);

  return (
    <section ref={sectionRef} className="relative py-24 bg-[#f4f7fb]">

      <div className="relative container mx-auto px-4 sm:px-6 lg:px-8">

        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <h2 className="font-display text-4xl sm:text-5xl lg:text-5xl font-semibold text-[#1e3a5f] leading-none tracking-tighter antialiased mb-4">
            Integrações e{" "}
            <span className="bg-gradient-to-r from-[#285992] via-[#427ab9] to-[#285992] bg-clip-text text-transparent">
              parceiros
            </span>{" "}
            da Foco Tecnologia
          </h2>
          <p className="text-slate-600 text-lg max-w-2xl mx-auto leading-relaxed">
            Do PMS aos canais de venda, marketing e pagamentos, conheça o ecossistema
            que se conecta à nossa plataforma, com sincronização em tempo real e sem retrabalho.
          </p>
        </motion.div>

        <Tabs
          value={activeTab}
          onValueChange={(v) => {
            setActiveTab(v);
            setHoveredIndex(null);
          }}
          className="w-full"
        >
          {/* Grid no mobile e no tablet, pílula em linha só a partir de `lg`,
              com o indicador deslizante (layoutId) por trás da aba ativa.
              Sticky logo abaixo do header — ver StickyTabsList.

              A pílula em linha começava em `md` (como no
              SmartIntegrationsTabs), mas aqui os rótulos são longos
              ("Marketing Hoteleiro", "Canal de vendas") e ela é
              `min-w-max`, então não encolhe: entre 768px e 1023px ela
              passava da largura útil e a PÁGINA INTEIRA ganhava scroll
              horizontal. Já acontecia com as 5 abas originais (798px numa
              área de 705px); a 6ª, RMS, levou pra 899px. Em `lg` a área
              útil é 960px e as 6 cabem. No tablet ficam num grid de 3
              colunas — 6 abas, 2 linhas cheias. O SmartIntegrationsTabs não
              precisou disso: os rótulos dele são curtos e as 5 abas ocupam
              630px a 768px. */}
          <StickyTabsList className="mb-10 lg:flex lg:justify-center" activeValue={activeTab}>
            {(isStuck) => (
              <TabsList
                // `max-md:[&>:last-child:nth-child(odd)]:col-span-2`: com
                // número ímpar de abas a última ficaria sozinha em meia largura
                // no grid de 2 colunas do mobile — era o caso com 5, antes da
                // RMS. Com 6 hoje não dispara; fica pra quando uma categoria
                // entrar ou sair. Restrito ao mobile porque no grid de 3
                // colunas do tablet "ímpar" não descreve a sobra.
                className={`grid grid-cols-2 md:grid-cols-3 w-full rounded-3xl lg:inline-flex lg:flex-nowrap lg:w-auto lg:rounded-full lg:min-w-max h-auto gap-1 p-1.5 border transition-all duration-300 max-md:[&>:last-child:nth-child(odd)]:col-span-2 ${
                  isStuck
                    ? "bg-white/75 backdrop-blur-xl border-white/60 shadow-xl shadow-slate-900/10"
                    : "bg-slate-100 border-slate-200"
                }`}
              >
                {categorias.map((cat) => {
                  const Icon = cat.icon;
                  const isActive = cat.id === activeTab;
                  return (
                    <TabsTrigger
                      key={cat.id}
                      value={cat.id}
                      className="relative flex items-center justify-center gap-2 px-4 py-3 text-sm font-medium rounded-xl lg:rounded-full lg:px-5 lg:py-2.5 lg:whitespace-nowrap"
                    >
                      {isActive && (
                        <motion.span
                          layoutId="pms-integrados-tab-indicator"
                          className="absolute inset-0 rounded-xl lg:rounded-full bg-gradient-to-r from-[#1e3a5f] to-[#285992] shadow-md shadow-[#285992]/25"
                          transition={{ type: "spring", stiffness: 380, damping: 32 }}
                        />
                      )}
                      <span className={`relative z-10 flex items-center gap-2 transition-colors duration-300 ${isActive ? "text-white" : "text-slate-600 hover:text-[#285992]"}`}>
                        <Icon className="w-4 h-4 shrink-0" />
                        {cat.label}
                      </span>
                    </TabsTrigger>
                  );
                })}
              </TabsList>
            )}
          </StickyTabsList>

          {categorias.map((cat) => (
            <TabsContent key={cat.id} value={cat.id} className="mt-0 outline-none">
              <div
                className={`grid ${gridColsClass(cat.itens.length)} gap-5`}
                onMouseLeave={() => setHoveredIndex(null)}
              >
                {cat.itens.map((pms, index) => (
                  <PmsCard
                    key={pms.id}
                    pms={pms}
                    index={index}
                    isHovered={hoveredIndex === index}
                    onEnter={() => setHoveredIndex(index)}
                    onSolicitar={() => setActivePms(pms)}
                  />
                ))}
              </div>
            </TabsContent>
          ))}
        </Tabs>

      </div>

      <PmsOrcamentoModal pms={activePms} onClose={() => setActivePms(null)} />
    </section>
  );
}

export { PmsIntegradosSection };
